import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { waUrl, DEFAULT_WA_MESSAGE } from '../data/site';

export default function WhatsAppFloat() {
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, type: 'spring', stiffness: 220, damping: 16 }}
      href={waUrl(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Falar com o engenheiro no WhatsApp"
      className="fixed bottom-6 right-6 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_16px_36px_-8px_rgba(37,211,102,0.6)] transition-transform hover:scale-110"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
      <MessageCircle size={26} className="relative" />
    </motion.a>
  );
}
